// extracted by mini-css-extract-plugin
module.exports = {"container":"LogoV2_container__Ku_hi"};